import React from "react";
import { useNavigate } from "react-router-dom";
import ReceiptIcon from "@mui/icons-material/Receipt";
import CancelIcon from "@mui/icons-material/Cancel";
import PrimaryButton from "../../../widgets/Buttons/PrimaryButton";
import ActionCard from "../../../widgets/ActionCard/ActionCard";
import routes from "../../../constants/routes";

const OrderManagementCard = ({ uamId, phone, vertical }) => {
  const navigate = useNavigate();

  const handleManageOrder = () => {
    if (!uamId) return;
    navigate(routes.modifyOrder.replace(":studentId", uamId), {
      state: { uamId, phone, vertical },
    });
  };

  const handleCancelOrder = () => {
    if (!uamId) return;
    navigate(routes.cancelOrder.replace(":studentId", uamId), {
      state: { uamId, phone, vertical },
    });
  };

  return (
    <ActionCard title="Order Management">
      <PrimaryButton sx={{ height: "35px" }} startIcon={<ReceiptIcon />} onClick={handleManageOrder}>
        Order Modification
      </PrimaryButton>
      <PrimaryButton sx={{ height: "35px" }} startIcon={<CancelIcon />} onClick={handleCancelOrder}>
        Order Cancellation
      </PrimaryButton>
    </ActionCard>
  );
};

export default OrderManagementCard;
